import Checkbox from "src/components/Checkbox";
import Input from "src/components/Input";
import PasswordInput from "src/components/PasswordInput";
import { IAuthErrors } from "../hooks/types";
import Anchor from "src/components/Anchor";
import Button from "src/components/Button";
import LoadingButton from "src/components/BulkOperations/_Shared/BulkActionButton/LoadingButton";
import Label from "src/components/Label";
import Overlay from "src/components/Overlay";
import { PATHS } from "src/common/constants";
import FontAwesomeIcon from 'src/components/Icon';
import { Terms } from "../Terms";
import { useEffect, useState } from 'react';

import pkg from "../../../../package.json";
import './login-form.scss';

interface ILoginFormProps {
  email: string;
  password: string;
  termsAndConditions: boolean;
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  setTermsAndConditions: (accepted: boolean) => void;
  errors: IAuthErrors;
  submit: () => void;
  loading: boolean;
}

export const LoginForm = ({
  email,
  password,
  termsAndConditions,
  errors,
  setEmail,
  setPassword,
  setTermsAndConditions,
  submit,
  loading,
}: ILoginFormProps) => {
  const [termsPopup, setTermsPopup] = useState(false);

  return (
    <form
      className="login-form"
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
    >
      <div className="sign-in-header">
        <div className="sign-in-headline">Log in to your dashboard</div>
      </div>
      <Input
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        label="Email Address"
        placeholder="eg., example@address.com"
        required
        block
        errors={errors.email.message}
        data-cy="login-email"
      />
      <PasswordInput
        value={password}
        onChange={setPassword}
        label="Password"
        required
        block
        errors={errors.password.message}
        data-cy="login-password"
      />
      <div>
        <div
          style={{ display: 'flex', alignItems: 'center', marginTop: '2.75rem' }}
        >
          <Checkbox
            label=""
            value={termsAndConditions}
            onChange={() => setTermsAndConditions(!termsAndConditions)}
            data-cy="login-terms"
          />
          <a style={{ paddingLeft: '1rem' }} className="input__label">
            <span>
              I accept the{' '}
              <span
                style={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
                onClick={() => setTermsPopup(true)}
              >
                Terms of Use
              </span>
            </span>
          </a>
        </div>

        <p className="input__error" style={{ margin: '0rem 0 3rem 0' }}>
          {errors.termsAndConditions.message}
        </p>
      </div>
      <div className="login-forgot-password">
        <Anchor path={PATHS.AUTH_FORGOT_PASSWORD} label="Forgot password?" />
      </div>
      <div className="sign-in-button">
        <LoadingButton
          actionText={loading ? 'Signing In...' : 'Sign In'}
          isSubmitting={loading}
          disabled={false}
          size={null}
          submit
          block
        />
      </div>
      <div style={{ textAlign: 'right' }}>
        <Label color="teal" label={`Version: ${pkg.version}`} />
      </div>
      <Overlay
        showOverlay={termsPopup}
        content={
          <div
            style={{
              width: 'auto',
              padding: '10rem',
              backgroundColor: 'white',
            }}
          >
            <div style={{ padding: '10px' }}>
              <button
                type="button"
                className="form__dismiss"
                style={{ color: '#454F5B' }}
                onClick={() => setTermsPopup(!termsPopup)}
              >
                <FontAwesomeIcon weight="light" glyph="arrow-left" />
              </button>

              <span
                className="heading-with-details-headline"
                style={{ padding: '0px 50px' }}
              >
                Terms of Use
              </span>
            </div>
            <div>
              {
                <div>
                  <Terms />
                  <div>&nbsp;</div>
                </div>
              }
              <div style={{ textAlign: 'center' }}>
                <Button
                  label="Accept"
                  onClick={() => {
                    setTermsAndConditions(true);
                    setTermsPopup(false);
                  }}
                  size={'small'}
                />
              </div>
            </div>
          </div>
        }
      ></Overlay>
    </form>
  );
};
